import React, { useContext } from 'react';
import s from './index.less';
import Icon from '@/components/Icon';
import { Tooltip } from '@/components';
import classNames from 'classnames';
interface ToolBtnProps {
  name: string;
  title: string;
  className?: string;
  active?: boolean;
  children?: any;
  onClick?: any;
  disabled?: boolean;
}

const ToolBtn: React.FC<ToolBtnProps> = (props) => {
  const { name, title, active, onClick, disabled } = props;
  console.log(disabled);
  return title ? (
    <Tooltip title={title} placement="right" align={{ offset: [-6, 0] }} className={s.tooltip}>
      <div
        className={classNames(s.toolBtn, active ? s.active : '', disabled ? s.disabled : '')}
        onClick={onClick}
      >
        <Icon name={name} className={s.name} size={18} mode="symbol"></Icon>
      </div>
    </Tooltip>
  ) : (
    <div
      className={classNames(s.toolBtn, active ? s.active : '', disabled ? s.disabled : '')}
      onClick={onClick}
    >
      <Icon name={name} className={s.name} size={18} mode="symbol"></Icon>
    </div>
  );
};

export default ToolBtn;
